'use client';

import FadeInImage from '@/components/FadeImage';
import { cn } from '@/utils/app.utils';
import { APP_NAME } from '@/utils/constants';

type Props = {
  // image to display in the right side (path of the image)
  image: string | undefined;
  // if the image should be displayed in mobile
  displayInMobile?: boolean;
  displayInAllTheme?: boolean;
  className?: string;
};
const AnimatedPageHeaderImage = ({
  image,
  className,
  displayInMobile = true,
}: Props) => {
  if (!image) return null;
  return (
    <div
      className="mb-8 flex flex-1 flex-col items-center md:mb-0"
    >
      {/* image is animated when first load */}
      <FadeInImage
        priority
        alt={APP_NAME}
        className={cn('relative h-full w-auto object-contain', className)}
        height={400}
        src={image}
        width={400}
        rootClassName={cn(
          'w-full lg:w-[700px] xl:w-[42vw] 2xl:[45vw] md:w-[60vw] xl:pt-12 md:flex md:flex-row max-md:justify-center',
          displayInMobile ? 'flex' : 'hidden'
        )}
      />
    </div>
  );
};

export default AnimatedPageHeaderImage;
